export default "/images/document.svg";